/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: dropdown-single-select-service.ts
 *
 * Created by kyang on 2019-12-04.
 */

function DropdownSingleSelectServiceConstructor (
    this: JS5Object,
    _: JS5Object,
    DropdownService: JS5Object
) {

    //=========//
    // Queries //
    //=========//

    // TODO: toggleSelection

    this.hasSelection = (dropdown: JS5Object) => {
        return !!dropdown.selection;
    };

    this.isItemSelected = (dropdown: JS5Object, item: any) => {
        return DropdownService.areItemsEqual(dropdown, dropdown.selection, item);
    };

    this.getSelectionText = (dropdown: JS5Object) => {
        if (this.hasSelection(dropdown)) {
            return DropdownService.getLabel(dropdown, dropdown.selection);
        }
        return undefined;
    };

    //==============//
    // Modification //
    //==============//

    // If item is selected, this function deselects it.
    // If item wasn't selected, previous selection is removed, and then this function selects the new.
    this.toggleItemSelection = (dropdown: JS5Object, newSelectedItem: any) => {
        if (DropdownService.areItemsEqual(dropdown, dropdown.selection, newSelectedItem)) {
            this.clearSelection(dropdown);
        } else {
            this.setSelection(dropdown, newSelectedItem);
        }
    };

    this.setSelection = (dropdown: JS5Object, newSelectedItem: any) => {
        if (DropdownService.isItemDisabled(dropdown, dropdown.selection) || DropdownService.isItemDisabled(dropdown, newSelectedItem)) {
            return;
        }
        dropdown.selection = newSelectedItem;
    };

    this.clearSelection = (dropdown: JS5Object) => {
        this.setSelection(dropdown, null);
    };
}

angular
    .module('prism-ui.components')
    .service(
        'DropdownSingleSelectService',
        DropdownSingleSelectServiceConstructor
    );
